import { Action, ActionCreator, Dispatch } from 'redux';
import { IUser } from '../../utils/userHandler';
import { NotificationActions } from '../notification/notification-actions';
import { getApi } from '../../api/ApiProvider';
import { IStore } from '..';

export enum AuthActionsTypes {
    REQUEST_LOGIN = '[AUTH][REQUEST] login',
    RESPONSE_LOGIN = '[AUTH][RESPONSE] login',
    ERROR_LOGIN = '[AUTH][ERROR] login',

    LOGOUT = '[AUTH][REQUEST] logout'
}

export interface AuthActionParams extends Action<AuthActionsTypes> {
    payload?: IUser
}

export class AuthActions {
    public login(user: string, pass: string): ActionCreator<void> {
        return (dispatch: Dispatch, getState: () => IStore) => {

            dispatch({ type: AuthActionsTypes.REQUEST_LOGIN });
            const notif = new NotificationActions();

            getApi().auth().login(user, pass)
                .then(ok => {

                    const action: AuthActionParams = {
                        type: AuthActionsTypes.RESPONSE_LOGIN,
                        payload: {
                            ...ok,
                            environment: getState().config.active
                        }
                    };

                    dispatch(action);
                    dispatch(notif.addSuccess(`Bienvenido ${ok.name}`) as any);
                }, err => {
                    dispatch({ type: AuthActionsTypes.ERROR_LOGIN });
                    dispatch(notif.addWarning('Error al iniciar sesión') as any);
                });


        };
    }

    public logout(): ActionCreator<void> {
        return (d: Dispatch) => {
            const action: AuthActionParams = {
                type: AuthActionsTypes.LOGOUT
            };

            d(action);
        }

    }
}



// WEBPACK FOOTER //
// ./src/store/auth/auth-actions.ts